var map = {
	"./pc-module-task-1.vue": 70067,
	"./pc-module-task-2.vue": 12660,
	"./pc-module-task-3.vue": 31508,
	"./pc-module-task-4.vue": 29980,
	"./pc-module-task-5.vue": 90780
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 23304;